module.exports = __webpack_public_path__ + "img/Timeline2019.07f5b895.png";